import { render } from "./ExhibitionNavbar.vue?vue&type=template&id=171185b1&scoped=true"
import script from "./ExhibitionNavbar.vue?vue&type=script&lang=js"
export * from "./ExhibitionNavbar.vue?vue&type=script&lang=js"

import "./ExhibitionNavbar.vue?vue&type=style&index=0&id=171185b1&lang=scss&scoped=true"

import exportComponent from "/Users/matt/Dev/unshackled-exhibition/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171185b1"]])

export default __exports__